import React from 'react';
import './PayBill.css';

const PayBill = () => {
    //PayBill Section
    return (
        <>
        <section>
            <div className="container paybill">
                <h1 className="text-center text-light py-3">Pay Bill</h1>
            </div>
            <div>
                <h1 className="text-center py-5">Coming Soon...</h1>
            </div>
        </section>
        </>
        
    );
};

export default PayBill;